import { React, useEffect, useState } from 'react';
import Downshift from 'downshift';
import { styled } from '@mui/system';
import SearchIcon from '@mui/icons-material/Search';
import SearchResultDisplay from '../SearchResultDisplay/SearchResultDisplay';

const SearchArea = styled('div')({
  display: 'flex',
  width: '50px',
  paddingBottom: '10px',
});

const InputArea = styled('input')({
  borderStyle: 'hidden',
  background: 'none',
  outline: 'none',
  fontFamily: 'Fjalla One',
  fontStyle: 'normal',
  fontWeight: '100px',
  fontSize: '18px',
  lineHeight: '10px',
  color: 'black',
  '&::placeholder': {
    color: 'rgb(166,146,123)',
    width: '50px',
  },
});

const SearchBarDivider = styled('Divider')({
  width: '234px',
  borderBottom: '2px solid rgb(166,146,123)',
  marginTop: '23px',
  position: 'absolute',
  marginLeft: '30px',
});

const AutocompleteSearch = ({
  items,
  relatedCafeOnChange,
  addedItems,
  setItems,
  addedFormikItems,
  setTheFormikItems,
  setSkipValue,
  ...rest
}) => {
  return (
    <>
      <Downshift
        {...rest}
        onChange={changeHandler(
          addedItems,
          setItems,
          addedFormikItems,
          setTheFormikItems,
          relatedCafeOnChange
        )}
      >
        {({ getInputProps, getItemProps, inputValue }) => {
          return (
            <div>
              <SearchArea>
                <SearchIcon style={{ padding: '1px', marginLeft: '25px', marginTop: '-1px' }} />
                <InputArea {...getInputProps()} type="text" />
                <SearchBarDivider />
              </SearchArea>

              <SearchResultDisplay
                displayedItems={items}
                input={inputValue}
                getItemInfo={getItemProps}
                currentItems={addedItems}
                setSkip={setSkipValue}
              />
            </div>
          );
        }}
      </Downshift>
    </>
  );
};

const changeHandler = (
  addedItems,
  setItems,
  addedFormikItems,
  setTheFormikItems,
  relatedCafeOnChange
) => {
  return (selectedItem, downshift) => {
    if (!selectedItem) return;
    const index = addedItems.findIndex((item) => item._id === selectedItem._id);
    if (index === -1) setItems([...addedItems, selectedItem]);
    if (index === -1) setTheFormikItems([...addedFormikItems, selectedItem._id]);
    relatedCafeOnChange([...addedFormikItems, selectedItem._id]);
    downshift.clearSelection();
  };
};

export default AutocompleteSearch;
